import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = [
    'folder',
  ]

  static values = {
    url: String,
  }

  async change() {
    const response = await fetch(
      `${this.urlValue}?folder_id=${encodeURIComponent(this.folderTarget.value)}`,
      {
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
        },
      },
    )

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status} ${response.statusText}`)
    }

    Turbo.renderStreamMessage(await response.text())
  }
}
